import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Showcase from './components/Showcase';
import TechCards from './components/TechCards';
import CtaCards from './components/CtaCards';
import BookRide from './components/BookRide';
import Footer from './components/Footer';
import Narsimha from './pages/Narsimha';
import Defence from './pages/Defence';
import Research from './pages/Research';
import Investor from './pages/Investor';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Accessories from './pages/Accessories';
import TestRide from './pages/TestRide';
import CinematicIntro from './components/CinematicIntro';
import { TRICOLOR_THEME_ENABLED } from './themeConfig';

function Home() {
  return (
    <div>
      <Header />
      <Hero />
      <Features />
      <Showcase />
      <TechCards />
      <CtaCards />
      <BookRide />
      <Footer />
    </div>
  );
}

function App() {
  const [showIntro, setShowIntro] = useState(false);

  useEffect(() => {
    if (TRICOLOR_THEME_ENABLED) {
      const hasSeenIntro = sessionStorage.getItem('acrlios_intro_seen');
      if (!hasSeenIntro) {
        setShowIntro(true);
      }
    }
  }, []);

  const handleIntroComplete = () => {
    sessionStorage.setItem('acrlios_intro_seen', 'true');
    setShowIntro(false);
  };

  return (
    <HashRouter>
      {showIntro && <CinematicIntro onComplete={handleIntroComplete} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/narsimha" element={<Narsimha />} />
        <Route path="/defence" element={<Defence />} />
        <Route path="/research" element={<Research />} />
        <Route path="/investor" element={<Investor />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/accessories" element={<Accessories />} />
        <Route path="/test-ride" element={<TestRide />} />
      </Routes>
    </HashRouter>
  );
}

export default App;

